<template lang="pug">
div
    BaseHeader(
        :titulo='$t("configuracaoParametros.listagem.titulo")',
        icon='el-icon-plus',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        :btnTexto='$t("configuracaoParametros.listagem.novaConfiguracao")',
        :exibeBotao='true',
        @btnHeaderClicado='irParaCadastro'
    )
    .configuracao-parametros
        .configuracao-parametros__info
            | {{ $t('configuracaoParametros.listagem.info') }}

        .configuracao-parametros__tabs
            el-tabs.demo-tabs(v-model='activeTab', @tab-click='handleTab')
                el-tab-pane(
                    v-for='tab in tabs',
                    :key='tab.id',
                    :label='tab.nome',
                    :name='tab.codigo'
                )
        router-view
</template>

<script>
import { configuracaoParametrosTabs as tabs } from '@/views/contratos-originacao/parametros/utils/assets/configuracaoParametros';
import { capitalize } from '@/utils/formatters';

export default {
    name: 'ConfiguracaoParametros',
    components: { BaseHeader: () => import('@/components/BaseHeader.vue') },
    data() {
        return {
            activeTab: 'PADRAO',
            tabs,
            nomeCadastro: '',
            nomeRota: ''
        };
    },
    mounted() {
        this.getTab();
    },
    methods: {
        getPath() {
            const pathSplit = this.$route.path.split('/');
            const tabPath = pathSplit[pathSplit.length - 1]
                ? pathSplit[pathSplit.length - 1]
                : 'padrao';

            return tabPath;
        },
        getTab() {
            const tab = this.getPath().toUpperCase();

            if (this.activeTab !== tab) {
                this.activeTab = tab;
            }
            this.handleTab();
        },
        obterRotas() {
            const tabName = capitalize(this.activeTab);
            const nomeRota =
                tabName === 'Padrao'
                    ? 'ConfiguracaoParametros'
                    : `Parametros${tabName}`;
            const nomeCadastro = `Parametros${tabName}Formulario`;

            return { nomeRota, nomeCadastro };
        },
        handleTab() {
            const { nomeRota, nomeCadastro } = this.obterRotas();
            const tabId = this.activeTab.toLowerCase();
            const tabPath = this.getPath();

            if (this.nomeRota !== nomeRota && tabPath !== tabId) {
                this.$router.push({ name: nomeRota });
            }
            this.nomeCadastro = nomeCadastro;
            this.nomeRota = nomeRota;
        },
        irParaCadastro() {
            this.$router.push({ name: this.nomeCadastro });
        }
    }
};
</script>

<style lang="scss">
.configuracao-parametros {
    padding: 20px;

    &__info {
        padding: 16px;
        margin: 20px 0;
        background-color: var(--white);
        border-radius: $default-border-radius;
        @include default-box-shadow();
    }
    &__tabs {
        .el-tabs__item {
            font-size: 18px;
            font-weight: bold;
            color: #aaa;
            width: 257px;
            text-align: center;
            &.is-active {
                color: $primary;
            }
        }
    }
}
</style>
